import React, { useState} from 'react';
import axios from 'axios';
import { Alert, Table, Form, Button, Modal } from 'react-bootstrap';

function GestionJoueurCotisation(props) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [confirmation,setConfirmation] = useState(false);
  const [type,setType] = useState();
  const [selectAll, setSelectAll] = useState(false); 
  const apiUrl = process.env.REACT_APP_API_URL;


  const handleCheckboxChange = (id_joueur) => {
    setSelectedPlayers((prevSelected) =>
      prevSelected.includes(id_joueur)
        ? prevSelected.filter((id) => id !== id_joueur)
        : [...prevSelected, id_joueur]
    );
  };

  const handleSelectAll = () => { 
    if (selectAll) {
      setSelectedPlayers([]);
    } else {
      const allPlayerIds = props.cotisationJoueur.map((joueur) => joueur.id_joueur);
      setSelectedPlayers(allPlayerIds);
    }
    setSelectAll(!selectAll);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setConfirmation(false);
    if(selectedPlayers.length === 0){
        setError("Aucun joueur sélectionné");
        setIsLoading(false);
        return;
    }
    
    try {
      await axios.patch(`${apiUrl}/cotisation/status`, {
        idEquipe : props.userData.user.donnée.results[0].id_equipe,
        status : type,
        joueur : selectedPlayers

      }, {
        withCredentials: true
      });
  
      setError(null);
      setIsLoading(false);
      window.location.reload(); 
  
    } catch (error) {
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };


  
  if (isLoading) {
    return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br />
        <span className="loader"></span>
      </div>
    );
  }

  return (
    <>
    {confirmation && (
      <>
        <Modal show={confirmation} onHide={() => {setConfirmation(false);setType()}}>
                <Modal.Header closeButton>
                  <Modal.Title>Confirmer votre action</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {type === 'confirmation' ? 'Voulez-vous vraiment confirmer la cotisation des joueurs sélectionnés ?' : type === 'Pas reçu' ? "Voulez-vous vraiment confirmer que vous n'avez pas reçu la contisation des joueurs sélectionnés ?" :  'Voulez-vous vraiment signaler un retard pour la cotisation des joueurs sélectionnés ?  Cette action bloquera leur accès au site.' }
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary"  onClick={() => {setConfirmation(false);setType()}}>
                    Quitter
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                    Confirmer
                  </Button>
                </Modal.Footer>
        </Modal>
      </>
    )}
      {props.cotisationJoueur && (
        <>
          {error && <Alert variant="danger">{error}</Alert>}
          <div>
            <h2 className="mb-4">Informations sur la cotisation des joueurs</h2>
            <div className="text-center">
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th style={{textAlign:'center'}}>  
                      <Form.Check
                      type="checkbox"
                      checked={selectedPlayers.length === props.cotisationJoueur.length}
                      onChange={handleSelectAll}
                      />
                  </th>
                  <th>Nom</th>
                  <th>Prénom</th>
                  <th>Date de paiement</th>
                  <th>Confirmation de paiement</th>
                  <th>Retard de paiement</th>
                </tr>
              </thead>
              <tbody>
                {props.cotisationJoueur.map((joueur) => (
                  <tr key={joueur.id_joueur}>
                    <td>
                      <Form.Check
                        type="checkbox"
                        checked={selectedPlayers.includes(joueur.id_joueur)}
                        onChange={() => handleCheckboxChange(joueur.id_joueur)}
                      />
                    </td>
                    <td>{joueur.nom}</td>
                    <td>{joueur.prenom}</td>
                    <td>{joueur.date_payement === null ? 'Cotisation pas encore payement payée' : joueur.date_payement}</td>
                    <td>{joueur.confirmationCotisation === 'true' ? 'Oui' : 'Non'}</td>
                    <td>{joueur.retardCotisation === 'true' ? 'Oui' : 'Non'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="text-center">
              <Button variant="success" onClick={() => {setConfirmation(true);setType('confirmation')}}>Confirmer le paiement</Button>{' '}
              <Button variant="secondary" onClick={() => {setConfirmation(true);setType('Pas reçu')}}>Paiement pas reçu</Button>{' '}
              <Button variant="danger" onClick={() => {setConfirmation(true);setType('retard')}}>Retard de paiement</Button>
            </div>
            <p className="text-muted mt-2">Cliquez sur les boutons ci-dessus pour confirmer le paiement ou signaler un retard de paiement pour les joueurs sélectionnés.</p>
          </div>
        </>
      )}
    </>
  );
}

export default GestionJoueurCotisation;

